__turbopack_context__.v({
  "dropdownWrapper": "SearchPanel-module-scss-module__J3aubG__dropdownWrapper",
  "header": "SearchPanel-module-scss-module__J3aubG__header",
  "headerTitle": "SearchPanel-module-scss-module__J3aubG__headerTitle",
  "resultsWrapper": "SearchPanel-module-scss-module__J3aubG__resultsWrapper",
  "search": "SearchPanel-module-scss-module__J3aubG__search",
  "searchPanelWrapper": "SearchPanel-module-scss-module__J3aubG__searchPanelWrapper",
});
